import React from "react";
import { Button, Card, CardBody, CardFooter, Image } from "@heroui/react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { PartnerFormModal } from "./partner-form-modal";
import partnersCreatePhoto from "../assets/images/home-partners-create.jpg";

interface PartnersSectionProps {
  onViewMoreClick: () => void;
}

export const PartnersSection: React.FC<PartnersSectionProps> = ({ onViewMoreClick }) => {
  const partnershipOptions = [
    {
      title: "Корпоративные подарки",
      description: "Создаем наборы с вашим логотипом для клиентов и партнеров",
      image: "https://img.heroui.chat/image/furniture?w=600&h=400&u=gift1"
    },
    {
      title: "Ароматизация помещений",
      description: "Разрабатываем уникальные ароматы для вашего бизнеса",
      image: "https://img.heroui.chat/image/furniture?w=600&h=400&u=diffuser4"
    },
    {
      title: "Индивидуальные коллекции",
      description: "Создаем эксклюзивные линейки продуктов под ваш бренд",
      image: "https://img.heroui.chat/image/furniture?w=600&h=400&u=candle6"
    }
  ];

  const partnershipBenefits = [
    {
      icon: "lucide:badge",
      title: "Узнаваемость бренда",
      description: "Уникальные ароматы помогут выделить ваш бренд среди конкурентов"
    },
    {
      icon: "lucide:gift",
      title: "Эксклюзивные подарки",
      description: "Создайте впечатляющие корпоративные подарки для ваших клиентов и партнеров"
    },
    {
      icon: "lucide:palette",
      title: "Полная кастомизация",
      description: "От аромата до упаковки — всё будет соответствовать вашему бренду"
    },
    {
      icon: "lucide:handshake",
      title: "Гибкие условия",
      description: "Индивидуальные условия сотрудничества для партнеров любого масштаба"
    }
  ];

  const caseStudies = [
    {
      company: "Premium Hotels",
      description: "Сеть отелей премиум-класса заказала фирменные ароматические диффузоры для лобби и номеров, что стало частью их узнаваемого стиля",
      result: "Увеличение узнаваемости бренда на 32%"
    },
    {
      company: "Design Studio",
      description: "Дизайн-студия заказала подарочные наборы свечей с фирменным ароматом для своих VIP-клиентов",
      result: "Повышение лояльности клиентов и рост повторных заказов"
    },
    {
      company: "Luxury Real Estate",
      description: "Агентство недвижимости использует наши свечи для создания атмосферы при показах объектов",
      result: "Сокращение среднего времени продажи объектов на 15%"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };

  const [isFormModalOpen, setIsFormModalOpen] = React.useState(false);

  return (
    <section className="py-24 bg-background" id="partners">
      <div className="container mx-auto px-6">
        {/* <div className="text-center mb-16"> */}
          {/* <h2 className="text-3xl md:text-4xl font-light mb-4">Для <span className="font-medium">партнёров</span></h2> */}
          {/* <p className="text-foreground/70 max-w-2xl mx-auto">
            Создайте уникальный ароматический опыт для вашего бизнеса. Мы предлагаем индивидуальные решения для компаний любого масштаба
          </p> */}
        {/* </div> */}

        {/* <motion.div 
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {partnershipOptions.map((option, index) => (
            <motion.div key={index} variants={itemVariants}>
              <Card className="border border-divider bg-content2/50 h-full product-card-hover" disableRipple>
                <CardBody className="p-0 overflow-hidden">
                  <Image
                    removeWrapper
                    alt={option.title}
                    className="w-full h-48 object-cover"
                    src={option.image}
                  />
                </CardBody>
                <CardFooter className="flex flex-col items-start p-6">
                  <h3 className="text-lg font-medium mb-2">{option.title}</h3>
                  <p className="text-foreground/70 text-sm mb-4">{option.description}</p>
                  {option.title === "Корпоративные подарки" ? (
                    <Button
                      as={Link}
                      to="/partners-gifts"
                      color="primary"
                      variant="flat"
                      endContent={<Icon icon="lucide:arrow-right" width={16} />}
                      className="mt-auto"
                    >
                      Подробнее
                    </Button>
                  ) : option.title === "Ароматизация помещений" ? (
                    <Button
                      as={Link}
                      to="/aroma-services"
                      color="primary"
                      variant="flat"
                      endContent={<Icon icon="lucide:arrow-right" width={16} />}
                      className="mt-auto"
                    >
                      Подробнее
                    </Button>
                  ) : (
                    <Button 
                      color="primary" 
                      variant="flat" 
                      endContent={<Icon icon="lucide:arrow-right" width={16} />}
                      className="mt-auto"
                    >
                      Подробнее
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </motion.div>
          ))}
        </motion.div> */}

        <div className="mt-10 bg-content2 p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-light mb-4">Создайте <span className="font-medium">уникальный аромат</span> для вашего бренда</h3>
              <p className="text-foreground/80 mb-6">
                Мы разрабатываем индивидуальные ароматические решения, которые подчеркнут идентичность вашего бренда и создадут незабываемые впечатления для ваших клиентов.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                  <span className="text-foreground/80">Консультация по ароматам и продукции</span>
                </li>
                <li className="flex items-start gap-3">
                  <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                  <span className="text-foreground/80">Разработка индивидуальных предложений</span>
                </li>
                <li className="flex items-start gap-3">
                  <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                  <span className="text-foreground/80">Брендирование упаковки и продукции</span>
                </li>
                <li className="flex items-start gap-3">
                  <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                  <span className="text-foreground/80">Гибкие условия сотрудничества</span>
                </li>
              </ul>
              <Button 
                color="primary" 
                size="lg"
                endContent={<Icon icon="lucide:send" width={18} />}
                onPress={() => setIsFormModalOpen(true)}
              >
                Оставить заявку
              </Button>
            </div>
            <div className="relative">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                viewport={{ once: true, margin: "-100px" }}
              >
                <img 
                  src={partnersCreatePhoto} 
                  alt="Корпоративное сотрудничество" 
                  className="w-full h-auto"
                />
              </motion.div>
              <div className="absolute -bottom-4 -right-4 bg-primary p-4 md:p-6">
                <p className="text-sm md:text-base font-medium text-primary-foreground">Доступно более 40+ <br />премиальных ароматов</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20">
          <h3 className="text-2xl md:text-3xl font-light text-center mb-10">Преимущества <span className="font-medium">сотрудничества</span></h3>
          
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
          >
            {partnershipBenefits.map((benefit, index) => (
              <motion.div key={index} variants={itemVariants}>
                <Card className="border border-divider bg-content2/50 h-full" disableRipple>
                  <CardBody className="p-6">
                    <div className="bg-primary/5 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                      <Icon icon={benefit.icon} className="text-primary" width={24} />
                    </div>
                    <h3 className="text-lg font-medium mb-2">{benefit.title}</h3>
                    <p className="text-foreground/70 text-sm">{benefit.description}</p>
                  </CardBody>
                </Card>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* <div className="mt-16">
          <h3 className="text-2xl md:text-3xl font-light text-center mb-10">Истории <span className="font-medium">успеха</span></h3>
          
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-3 gap-6"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
          >
            {caseStudies.map((caseStudy, index) => (
              <motion.div key={index} variants={itemVariants}>
                <Card className="border border-divider bg-content2/50 h-full" disableRipple>
                  <CardBody className="p-6">
                    <h3 className="text-lg font-medium mb-4">{caseStudy.company}</h3>
                    <p className="text-foreground/70 text-sm mb-4">{caseStudy.description}</p>
                    <div className="bg-primary/5 p-3 rounded-md">
                      <p className="text-sm font-medium">{caseStudy.result}</p>
                    </div>
                  </CardBody>
                </Card>
              </motion.div>
            ))}
          </motion.div>
        </div> */}

        <div className="mt-12 text-center">
          <Button 
            color="primary" 
            variant="bordered" 
            size="lg"
            className="font-medium"
            endContent={<Icon icon="lucide:arrow-right" width={18} />}
            onPress={onViewMoreClick}
          >
            Подробнее о сотрудничестве
          </Button>
        </div>


      </div>
      <PartnerFormModal 
        isOpen={isFormModalOpen} 
        onClose={() => setIsFormModalOpen(false)} 
      />
    </section>
  );
};